import { animated, useSpring } from '@react-spring/web';
import { default as React, useEffect, useRef, useState } from 'react';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import Typewriter from '../../components/action/Typewriter';
import LoginButton from '../../components/login/LoginButton';
import Logo from '../../components/Logo/Logo';
import ThemedText from '../../components/theme/ThemedText';
import ThemeLogo from '../../components/theme/ThemeLogo';
import { useGlobalState } from '../../state/GlobalStateProvider';
import chatData from './message.json';

const ChatStep = ({ onNext }) => {
  const fadeInStyles = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
  });

  const chatBoxDelay = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
    delay: 2500,
  });
  const taskBarDelay = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
    delay: 1000,
  });

  const optionBarDelay = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
    delay: 2500,
  });

  const chatUp = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    config: { tension: 200, friction: 20 },
  });

  const [{ user }] = useGlobalState();
  const [currentNode, setCurrentNode] = useState('start');
  const [messages, setMessages] = useState([]);
  const [userDetails, setUserDetails] = useState({ name: 'Unknown', img: require('../../assets/unknown.png') });
  const messagesEndRef = useRef(null);
  const [hideOptions, setHideOptions] = useState(true);
  const [applyAnimation, setApplyAnimation] = useState(false);
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  useEffect(() => {
    if (currentNode === 'start') {
      if (chatData[currentNode]?.messages) {
        startingMessages();
      }
    }
  }, [currentNode]);

  async function startingMessages() {
    const updatedMessages = [...messages];
    const botMessages = chatData[currentNode].messages || [];
    await delay(3000);
    for (let index = 0; index < botMessages.length; index++) {
      setMessages([...updatedMessages, { text: 'Typing...', sender: 'bot' }]);

      await delay(1000);

      setMessages([...updatedMessages, botMessages[index]]);
      updatedMessages.push(botMessages[index]);
      await delay(500);
    }
    setHideOptions(false);
  }

  const handleUserChoice = async choiceText => {
    setHideOptions(true);
    const updatedMessages = [...messages, { text: choiceText, sender: 'user' }];
    setMessages(updatedMessages);

    const nextNode = chatData[currentNode].options.find(option => option.text === choiceText)?.next;
    console.log('Step 1', { messages, updatedMessages });
    if (nextNode) {
      const botMessages = chatData[nextNode]?.messages || [];

      for (let index = 0; index < botMessages.length; index++) {
        setMessages([...updatedMessages, { text: 'Typing...', sender: 'bot' }]);

        await delay(Math.min(String(botMessages[index].text).split(' ').length * 150 , 3000));
        setMessages([...updatedMessages, botMessages[index]]);
        updatedMessages.push(botMessages[index]);
        await delay(500);
      }

      setCurrentNode(nextNode);
      if (nextNode == 'whoAreYou') {
        setUserDetails({ name: 'Chief Application Officer Merci', img: require('../../assets/merci.jpg') });
        // setApplyAnimation(true);
        // setTimeout(() => setApplyAnimation(false), 1000);
      }
      setHideOptions(false);
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  function handleNext() {
    localStorage.setItem(`onboarding_${user?.address}`, true);
    onNext();
  }

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <animated.div className='chat_step_wrapper'>
      <div className='logo_height'>
        <ThemeLogo icon={'mercleLogoWhite'} />
      </div>
      <FlexboxColumn className='chat_step_wrapper__chatbox' gap='1.5rem'>
        <Flexbox style={taskBarDelay} className={`chat_step_wrapper__chatbox__details ${applyAnimation ? 'glow-up' : ''}`} fw justifyContent='flex-start'>
          <Logo width={'4rem'} height={'4rem'} src={userDetails.img} borderRadius='50%' />
          <div>
            <ThemedText.h4>
              <Typewriter text={userDetails?.name} startDelay={1200} duration={400} />
            </ThemedText.h4>
            <ThemedText.p>
              {' '}
              <Typewriter text={'🟢 Online'} startDelay={1650} duration={200} />
            </ThemedText.p>
          </div>
        </Flexbox>
        <FlexboxColumn style={chatBoxDelay} className='chat_step_wrapper__chatbox__messages' justifyContent={'flex-start'}>
          {messages.map((msg, index) => (
            <>
              {msg.text === 'connect_wallet' ? (
                <div>
                  <LoginButton fallback={handleNext} />
                </div>
              ) : (
                <animated.div style={chatUp} key={index} className={`chat_step_wrapper__chatbox__messages__${msg.sender === 'user' ? 'user' : 'bot'}`}>
                  {msg.text}
                </animated.div>
              )}
            </>
          ))}
          <div ref={messagesEndRef} />
        </FlexboxColumn>
        <FlexboxColumn style={optionBarDelay} className='chat_step_wrapper__chatbox__options' gap='1rem' fw>
          {!hideOptions &&
            chatData[currentNode]?.options &&
            chatData[currentNode].options.map((option, index) => (
              <div key={index} className='chat_step_wrapper__chatbox__options__option' onClick={() => handleUserChoice(option.text)}>
                {option?.text}
              </div>
            ))}
        </FlexboxColumn>
      </FlexboxColumn>
    </animated.div>
  );
};

export default ChatStep;
